// extracted by mini-css-extract-plugin
export default {"wired":"wB8BE5","name":"S2v2ZM"};